import { render, staticRenderFns } from "./DialogEvent.vue?vue&type=template&id=30fc063b&scoped=true"
import script from "./DialogEvent.vue?vue&type=script&lang=js"
export * from "./DialogEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc063b",
  null
  
)

export default component.exports